var _rect, _rect2, _rect3, _rect4, _rect5, _ellipse, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse2, _rect11, _rect12, _rect13, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHealthPilatesServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 110,
    viewBox: "0 0 131 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 39.4033,
    width: 79.9229,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4238,
    y: 49.9814,
    width: 78.6561,
    height: 23.5119,
    rx: 11.756,
    transform: "rotate(-35 10.4238 49.9814)",
    fill: "#EEC2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 56.2285,
    width: 92.5423,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3027,
    y: 73.0547,
    width: 84.1293,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 89.8809,
    width: 75.7164,
    height: 16.8259,
    rx: 8.41293,
    fill: "#EEC2B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7142,
    cy: 70.9512,
    rx: 33.6517,
    ry: 35.755,
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 35.1943,
    width: 79.9229,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4238,
    y: 45.7725,
    width: 78.6561,
    height: 23.5119,
    rx: 11.756,
    transform: "rotate(-35 10.4238 45.7725)",
    fill: "#FFDCD5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 52.0195,
    width: 92.5423,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 68.8457,
    width: 84.1293,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3008,
    y: 85.6719,
    width: 75.7164,
    height: 16.8259,
    rx: 8.41293,
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7142,
    cy: 66.7423,
    rx: 33.6517,
    ry: 35.755,
    fill: "#FFDCD5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1562,
    y: 30.9873,
    width: 84.1417,
    height: 49.8618,
    fill: "#00C968"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1562,
    y: 31.0332,
    width: 28.0472,
    height: 49.8618,
    fill: "#A4EECB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1855,
    y: 37.2656,
    width: 49.8618,
    height: 37.3963,
    fill: "#A4EECB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6366 73.21L52.7767 66.0391H50.4013V64.1343H52.2837L50.4237 56.9858H52.8215L54.5246 64.1343H57.3929L59.1857 56.9858H61.6507L63.4434 64.1343H66.3117L68.0148 56.9858H70.4126L68.5526 64.1343H70.435V66.0391H68.0596L66.1773 73.21H63.7123L61.8523 66.0391H58.984L57.124 73.21H54.6366ZM54.9952 66.0391L55.8467 69.6469H56.0036L56.9223 66.0391H54.9952ZM59.4994 64.1343H61.3593L60.4854 60.7953H60.3509L59.4994 64.1343ZM63.9364 66.0391L64.8327 69.6693H64.9672L65.8412 66.0391H63.9364Z",
    fill: "#00C968"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealthPilatesServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcHealthPilatesServiceBodyMobile.1a0d96a4f6d43c52eb09911c0e9442c8.svg";
export { ForwardRef as ReactComponent };